import {
  AlignedShowPageItemStatsValue,
  ShowPageItemStatsLabel,
} from 'src/components/PageLayout/ShowPage'
import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'

export const PropertiesGrid = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 24px;
  width: 100%;
`

export const PropertiesRow = styled.div`
  &:nth-child(even) {
    background-color: ${palette.neutral[30]};
  }
  padding: 16px;
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: subgrid;
  align-items: center;
`

export const PropertiesLabel = styled(ShowPageItemStatsLabel)`
  grid-column: 1 / 2;
`

export const PropertiesValue = styled(AlignedShowPageItemStatsValue)`
  grid-column: 2 / -1;
  input,
  span {
    width: max-content;
  }
`
